import Vue from 'vue';
import Modal from './index';
import i18n from '@app/plugins/i18n';
import merge from 'lodash-es/merge';

export class ModalService {
  constructor(service = null) {
    this.modal = Modal;
    this.subscribers = {};
    this.service = service;
    this.size = {
      confirm: '416px',
      default: '520px',
      default_plus: '630px',
      large: '720px'
    };
  }

  on(event, handler) {
    this.subscribers[event] = [handler];
    return this;
  }

  $emit(event, data) {
    (this.subscribers[event] || []).forEach(i => i(data));
  }

  $removeItem(id, item, opts = {}) {
    return this.$removeDeepItem({ id: id }, item, opts);
  }

  $removeDeepItem(params_path = {}, item, opts) {
    if (!this.service || !this.service.constructor.name) {
      throw Error(`Service is required in ModalService`);
    }

    if (!('removeItemModal' in this.service)) {
      throw Error(`removeItemModal not exist in ${this.service.constructor.name}`);
    }

    const { id } = params_path;

    return this.$confirm(
      merge(
        {
          title: i18n.t('shared.component.modal.confirm'),
          content: i18n.t('shared.component.modal.confirm_content', {
            id: `<strong>${id}</strong>`
          }),
          loading: true,
          width: this.size.confirm,

          onOk: () => {
            this.service
              .removeItemModal(params_path)
              .then(() => {
                this.$emit('success');
                this.modal.remove();
              })
              .catch(e => {
                this.$emit('fail');
                this.modal.setLoading(false);
                Vue.noty.server_error(e);
              });
          },
          onCancel: () => this.$emit('cancel')
        },
        opts
      )
    );
  }

  $open(opts = {}) {
    this.modal.confirm(
      merge(
        {
          showCancel: true,
          closable: true,
          maskClosable: true,
          customFooter: true,
          width: this.size.default,
          onCancel: () => this.$emit('cancel')
        },
        opts,
        {
          className: `zorra-modal zorra-modal--${opts.render ? 'render' : 'confirm'} ${
            opts.className ? opts.className : ''
          }`
        }
      )
    );
    return this;
  }

  $confirm(opts = {}) {
    return this.$open(
      merge(
        {
          customFooter: false,
          width: this.size.confirm
        },
        opts
      )
    );
  }
}
